/*** IMPORTS FROM imports-loader ***/
(function() {
var fix = module.exports=0;
var define = false;
var exports = false;

// Validation errors messages for Parsley
// Load this after Parsley

Parsley.addMessages('ru', {
  dateiso:  "Это значение должно быть корректной датой (ГГГГ-ММ-ДД).",
  minwords: "Это значение должно содержать не менее %s слов.",
  maxwords: "Это значение должно содержать не более %s слов.",
  words:    "Это значение должно содержать от %s до %s слов.",
  gt:       "Это значение должно быть больше.",
  gte:      "Это значение должно быть больше или равно.",
  lt:       "Это значение должно быть меньше.",
  lte:      "Это значение должно быть меньше или равно.",
  notequalto: "Это значение должно отличаться."
});

}.call(window));


//////////////////
// WEBPACK FOOTER
// ../node_modules/imports-loader?this=>window,fix=>module.exports=0,define=>false,exports=>false!../node_modules/parsleyjs/dist/i18n/ru.extra.js
// module id = nsH8
// module chunks = 4